import { computed } from 'vue';
import { usePageDataStore } from '@/stores/pageDataStore';
/** @import { IPageParams } from '@/types/definitions' */

/**
 * Use page parameters from the Server.
 *
 * @returns {IPageParams} - static object with page params from the server.
 */
export default function usePageData() {
  const pageDataStore = usePageDataStore();
  return computed(() => pageDataStore.pageData);
}
